export default "__VITE_ASSET__0bb612ad__"